<template>
  <div class="body">
    <div class="banner">
      <img :src="banner" />
    </div>
    <div class="contents">
      <div class="contents-left">
        <img class="contents-banner" :src="titleImg" />
        <p class="contents-title">
          MOVIBOT作为全新一站式供需对接"云采购"平台，致力于做全球值得信赖的工业生态链数字化服务商。
          平台通过汇聚中国工业机器人上下游名、特、优生产制造企业及工业机器人企业，融合了独一无二的产业链产品，实现上下游供需畅通、贸易联通。
          服务全域，增值万家。平台利用互联网技术，依托巨大销售网络，实现产品可溯源，生产过程规范标准，产品出产检验合格，做质量安全、品质优异的产品，实现上游供应商与下游生产企业消费生态增值，助力广大生产制造企业提质、增效、降本、减存。
        </p>
        <div class="contents-list">
          <div class="contents-list-item" v-for="(item, index) in bannerList">
            <img :src="item.img" />
          </div>
        </div>
      </div>
      <div class="contents-right">
        <p class="contents-right-title">联系我们获得更多帮助</p>
        <p class="contents-right-lable">填写表格并在2个工作日内给予您回复</p>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          labelPosition="left"
          class="registerform"
        >
          <!-- 名字-->
          <el-form-item prop="realname">
            <el-input v-model="ruleForm.realname" placeholder="名"></el-input>
          </el-form-item>

          <!--姓氏      -->
          <el-form-item prop="surname">
            <el-input v-model="ruleForm.surname" placeholder="姓"></el-input>
          </el-form-item>

          <!--邮箱地址      -->
          <el-form-item prop="mail">
            <el-input v-model="ruleForm.mail" placeholder="邮箱"></el-input>
          </el-form-item>

          <!--电话      -->
          <el-form-item prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="电话"></el-input>
          </el-form-item>

          <!--公司名称      -->
          <el-form-item prop="company">
            <el-input
              v-model="ruleForm.company"
              placeholder="公司名称"
            ></el-input>
          </el-form-item>

          <!--行业      -->
          <el-form-item prop="industry">
            <el-select v-model="ruleForm.industry" placeholder="请选择行业领域">
              <el-option label="工业机器人" value="1"></el-option>
              <el-option label="消费品加工制造" value="2"></el-option>
              <el-option label="智能家庭及商业应用" value="3"></el-option>
              <el-option label="仓储物流" value="4"></el-option>
              <el-option label="食品行业" value="5"></el-option>
              <el-option label="医疗行业" value="6"></el-option>
              <el-option label="汽车行业" value="7"></el-option>
              <el-option label="机械设备制造" value="8"></el-option>
              <el-option label="电子行业" value="9"></el-option>
            </el-select>
          </el-form-item>

          <!--国家 -->
          <el-form-item prop="country">
            <el-select placeholder="请选择国籍" v-model="ruleForm.country">
              <el-option-group
                v-for="group in country"
                :key="group.label"
                :label="group.label"
              >
                <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                >
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    item.value
                  }}</span>
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>

          <el-form-item prop="content">
            <el-input
              type="textarea"
              v-model="ruleForm.content"
              :rows="3"
              placeholder="让我们了解您遇到的问题，我们能帮您什么？"
            ></el-input>
          </el-form-item>

          <el-form-item class="xieyeitem" prop="checked" label-width="0">
            <el-checkbox class="xieyi" v-model="ruleForm.checked"
              >我已阅读并接受
              <span class="yinsi"
                ><router-link :to="{ name: 'privacy' }" tag="a" target="_blank"
                  >隐私政策</router-link
                ></span
              ></el-checkbox
            >
          </el-form-item>

          <el-form-item class="contacusbotton">
            <el-button round type="primary" @click="submitForm('ruleForm')"
              >提交</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var revalidatexieyi = (rule, value, callback) => {
      if (value === false) {
        callback(new Error("请同意协议"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        realname: "",
        surname: "",
        company: "",
        country: "",
        city: 1,
        mail: "",
        industry: "",
        checked: "",
        content: ""
      },
      rules: {
        realname: [{ required: true, message: "请输入名", trigger: "blur" }],
        surname: [{ required: true, message: "请输入姓", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        company: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          {
            min: 3,
            max: 16,
            message: "长度在 3 到 16 个字符",
            trigger: "blur"
          }
        ],
        country: [{ required: true, message: "请选择国家", trigger: "change" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        mail: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: "请检查邮箱格式",
            trigger: "blur"
          }
        ],
        industry: [
          { required: true, message: "请选择行业", trigger: "change" }
        ],
        checked: [
          { required: true, message: "还没有同意协议", trigger: "change" },
          { validator: revalidatexieyi, trigger: "change", required: true }
        ]
      },
      country: [
        {
          label: "热门国家",
          options: [{ value: "China", label: "中国" }]
        },
        {
          label: "所有国家",
          options: [
            { value: "Angola", label: "安哥拉" },
            { value: "Afghanistan", label: "阿富汗" },
            { value: "Albania", label: "阿尔巴尼亚" },
            { value: "Algeria", label: "阿尔及利亚" },
            { value: "Andorra", label: "安道尔共和国" },
            { value: "Anguilla", label: "安圭拉岛" },
            { value: "Antigua and Barbuda", label: "安提瓜和巴布达" },
            { value: "Argentina", label: "阿根廷" },
            { value: "Armenia", label: "亚美尼亚" },
            { value: "Ascension", label: "阿森松" },
            { value: "Australia", label: "澳大利亚" },
            { value: "Austria", label: "奥地利" },
            { value: "Azerbaijan", label: "阿塞拜疆" },
            { value: "Bahamas", label: "巴哈马" },
            { value: "Bahrain", label: "巴林" },
            { value: "Bangladesh", label: "孟加拉国" },
            { value: "Barbados", label: "巴巴多斯" },
            { value: "Belarus", label: "白俄罗斯" },
            { value: "Belgium", label: "比利时" },
            { value: "Belize", label: "伯利兹" },
            { value: "Benin", label: "贝宁" },
            { value: "Bermuda Is", label: "百慕大群岛" },
            { value: "Bolivia", label: "玻利维亚" },
            { value: "Botswana", label: "博茨瓦纳" },
            { value: "Brazil", label: "巴西" },
            { value: "Brunei", label: "文莱" },
            { value: "Bulgaria", label: "保加利亚" },
            { value: "Burkina Faso", label: "布基纳法索" },
            { value: "Burma", label: "缅甸" },
            { value: "Burundi", label: "布隆迪" },
            { value: "Cameroon", label: "喀麦隆" },
            { value: "Canada", label: "加拿大" },
            { value: "Cayman Is", label: "开曼群岛" },
            { value: "Central African Republic", label: "中非共和国" },
            { value: "Chad", label: "乍得" },
            { value: "Chile", label: "智利" },
            { value: "China", label: "中国" },
            { value: "Colombia", label: "哥伦比亚" },
            { value: "Congo", label: "刚果" },
            { value: "Cook Is", label: "库克群岛" },
            { value: "Costa Rica", label: "哥斯达黎加" },
            { value: "Cuba", label: "古巴" },
            { value: "Cyprus", label: "塞浦路斯" },
            { value: "Czech Republic", label: "捷克" },
            { value: "Denmark", label: "丹麦" },
            { value: "Djibouti", label: "吉布提" },
            { value: "Dominica Rep", label: "多米尼加共和国" },
            { value: "Ecuador", label: "厄瓜多尔" },
            { value: "Egypt", label: "埃及" },
            { value: "EI Salvador", label: "萨尔瓦多" },
            { value: "Estonia", label: "爱沙尼亚" },
            { value: "Ethiopia", label: "埃塞俄比亚" },
            { value: "Fiji", label: "斐济" },
            { value: "Finland", label: "芬兰" },
            { value: "France", label: "法国" },
            { value: "French Guiana", label: "法属圭亚那" },
            { value: "French Polynesia", label: "法属玻利尼西亚" },
            { value: "Gabon", label: "加蓬" },
            { value: "Gambia", label: "冈比亚" },
            { value: "Georgia", label: "格鲁吉亚" },
            { value: "Germany", label: "德国" },
            { value: "Ghana", label: "加纳" },
            { value: "Gibraltar", label: "直布罗陀" },
            { value: "Greece", label: "希腊" },
            { value: "Grenada", label: "格林纳达" },
            { value: "Guam", label: "关岛" },
            { value: "Guatemala", label: "危地马拉" },
            { value: "Guinea", label: "几内亚" },
            { value: "Guyana", label: "圭亚那" },
            { value: "Haiti", label: "海地" },
            { value: "Honduras", label: "洪都拉斯" },
            { value: "Hungary", label: "匈牙利" },
            { value: "Iceland", label: "冰岛" },
            { value: "India", label: "印度" },
            { value: "Indonesia", label: "印度尼西亚" },
            { value: "Iran", label: "伊朗" },
            { value: "Iraq", label: "伊拉克" },
            { value: "Ireland", label: "爱尔兰" },
            { value: "Israel", label: "以色列" },
            { value: "Italy", label: "意大利" },
            { value: "Ivory Coast", label: "科特迪瓦" },
            { value: "Jamaica", label: "牙买加" },
            { value: "Japan", label: "日本" },
            { value: "Jordan", label: "约旦" },
            { value: "Kampuchea (Cambodia )", label: "柬埔寨" },
            { value: "Kazakstan", label: "哈萨克斯坦" },
            { value: "Kenya", label: "肯尼亚" },
            { value: "Korea", label: "韩国" },
            { value: "Kuwait", label: "科威特" },
            { value: "Kyrgyzstan", label: "吉尔吉斯坦" },
            { value: "Laos", label: "老挝" },
            { value: "Latvia", label: "拉脱维亚" },
            { value: "Lebanon", label: "黎巴嫩" },
            { value: "Lesotho", label: "莱索托" },
            { value: "Liberia", label: "利比里亚" },
            { value: "Libya", label: "利比亚" },
            { value: "Liechtenstein", label: "列支敦士登" },
            { value: "Lithuania", label: "立陶宛" },
            { value: "Luxembourg", label: "卢森堡" },
            { value: "Madagascar", label: "马达加斯加" },
            { value: "Malawi", label: "马拉维" },
            { value: "Malaysia", label: "马来西亚" },
            { value: "Maldives", label: "马尔代夫" },
            { value: "Mali", label: "马里" },
            { value: "Malta", label: "马耳他" },
            { value: "Mariana Is", label: "马里亚那群岛" },
            { value: "Martinique", label: "马提尼克" },
            { value: "Mauritius", label: "毛里求斯" },
            { value: "Mexico", label: "墨西哥" },
            { value: "Moldova", label: "摩尔多瓦" },
            { value: "Monaco", label: "摩纳哥" },
            { value: "Mongolia", label: "蒙古" },
            { value: "Montserrat Is", label: "蒙特塞拉特岛" },
            { value: "Morocco", label: "摩洛哥" },
            { value: "Mozambique", label: "莫桑比克" },
            { value: "Namibia", label: "纳米比亚" },
            { value: "Nauru", label: "瑙鲁" },
            { value: "Nepal", label: "尼泊尔" },
            { value: "Netheriands Antilles", label: "荷属安的列斯" },
            { value: "Netherlands", label: "荷兰" },
            { value: "New Zealand", label: "新西兰" },
            { value: "Nicaragua", label: "尼加拉瓜" },
            { value: "Niger", label: "尼日尔" },
            { value: "Nigeria", label: "尼日利亚" },
            { value: "North Korea", label: "朝鲜" },
            { value: "Norway", label: "挪威" },
            { value: "Oman", label: "阿曼" },
            { value: "Pakistan", label: "巴基斯坦" },
            { value: "Panama", label: "巴拿马" },
            { value: "Papua New Cuinea", label: "巴布亚新几内亚" },
            { value: "Paraguay", label: "巴拉圭" },
            { value: "Peru", label: "秘鲁" },
            { value: "Philippines", label: "菲律宾" },
            { value: "Poland", label: "波兰" },
            { value: "Portugal", label: "葡萄牙" },
            { value: "Puerto Rico", label: "波多黎各" },
            { value: "Qatar", label: "卡塔尔" },
            { value: "Reunion", label: "留尼旺" },
            { value: "Romania", label: "罗马尼亚" },
            { value: "Russia", label: "俄罗斯" },
            { value: "Saint Lueia", label: "圣卢西亚" },
            { value: "Saint Vincent", label: "圣文森特岛" },
            { value: "Samoa Eastern", label: "东萨摩亚(美)" },
            { value: "Samoa Western", label: "西萨摩亚" },
            { value: "San Marino", label: "圣马力诺" },
            { value: "Sao Tome and Principe", label: "圣多美和普林西比" },
            { value: "Saudi Arabia", label: "沙特阿拉伯" },
            { value: "Senegal", label: "塞内加尔" },
            { value: "Seychelles", label: "塞舌尔" },
            { value: "Sierra Leone", label: "塞拉利昂" },
            { value: "Singapore", label: "新加坡" },
            { value: "Slovakia", label: "斯洛伐克" },
            { value: "Slovenia", label: "斯洛文尼亚" },
            { value: "Solomon Is", label: "所罗门群岛" },
            { value: "Somali", label: "索马里" },
            { value: "South Africa", label: "南非" },
            { value: "Spain", label: "西班牙" },
            { value: "SriLanka", label: "斯里兰卡" },
            { value: "St.Lucia", label: "圣卢西亚" },
            { value: "St.Vincent", label: "圣文森特" },
            { value: "Sudan", label: "苏丹" },
            { value: "Suriname", label: "苏里南" },
            { value: "Swaziland", label: "斯威士兰" },
            { value: "Sweden", label: "瑞典" },
            { value: "Switzerland", label: "瑞士" },
            { value: "Syria", label: "叙利亚" },
            { value: "Tajikstan", label: "塔吉克斯坦" },
            { value: "Tanzania", label: "坦桑尼亚" },
            { value: "Thailand", label: "泰国" },
            { value: "Togo", label: "多哥" },
            { value: "Tonga", label: "汤加" },
            { value: "Trinidad and Tobago", label: "特立尼达和多巴哥" },
            { value: "Tunisia", label: "突尼斯" },
            { value: "Turkey", label: "土耳其" },
            { value: "Turkmenistan", label: "土库曼斯坦" },
            { value: "Uganda", label: "乌干达" },
            { value: "Ukraine", label: "乌克兰" },
            { value: "United Arab Emirates", label: "阿拉伯联合酋长国" },
            { value: "United Kiongdom", label: "英国" },
            { value: "United States of America", label: "美国" },
            { value: "Uruguay", label: "乌拉圭" },
            { value: "Uzbekistan", label: "乌兹别克斯坦" },
            { value: "Venezuela", label: "委内瑞拉" },
            { value: "Vietnam", label: "越南" },
            { value: "Yemen", label: "也门" },
            { value: "Yugoslavia", label: "南斯拉夫" },
            { value: "Zimbabwe", label: "津巴布韦" },
            { value: "Zaire", label: "扎伊尔" },
            { value: "Zambia", label: "赞比亚" }
          ]
        }
      ],
      banner: "/static/aboutus/banner.png",
      titleImg: "/static/aboutus/logo.png",
      bannerList: [
        {
          id: 1,
          img: "/static/aboutus/chanyelian.png"
        },
        {
          id: 2,
          img: "/static/aboutus/pinpai.jpg"
        },
        {
          id: 3,
          img: "/static/aboutus/zidonghua.png"
        }
      ]
    };
  },
  metaInfo() {
    return {
      title: "Movibot官网_工业机器人上下游供应链",
      meta: [
        {
          name: "keywords",
          content:
            "工业机器人_工业机器人上下游供应链_工业机器人品牌_工业自动化设备_行业解决方案"
        },
        {
          name: "description",
          content:
            "Movibot汇聚中国工业机器人上下游供应链优质工业机器人品牌,为工业机器人,智能家庭及商业应用,仓储物流,食品行业,医药行业,汽车行业,机械设备制造,电子行业提供工业自动化设备和行业解决方案"
        }
      ]
    };
  },
  methods: {
    resetForm() {
      this.ruleForm = {};
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api.user.savehelp(this.ruleForm).then(res => {
            //注册成功， 跳转到登陆页面
            if (res.data.errno == 0) {
              this.$FUnitls.showInfo("提交成功", "success");

              var form = {
                realname: "",
                surname: "",
                company: "",
                mail: "",
                content: ""
              };
              form.checked = this.ruleForm.checked;
              form.country = this.ruleForm.country;
              form.industry = this.ruleForm.industry;
              this.ruleForm = form;
            } else {
              this.$FUnitls.showInfo("提交成功", "error");
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.banner {
  width: 100%;
}
.banner img {
  width: 100%;
}
.contents {
  overflow: hidden;
}
.contents-left {
  width: 754px;
  float: left;
  text-align: center;
  margin-bottom: 60px;
}
.contents-right {
  margin-left: 56px;
  width: 350px;
  float: right;
}
.contents-list {
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 0 5px;
}
.contents-list-item {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
  width: 196px;
  height: 171px;
  border-radius: 10px;
  overflow: hidden;
}
.contents-list-item img {
  width: 100%;
}
.contents-title {
  text-align: justify;

  color: #474747;
  margin-bottom: 67px;

  text-indent: 2em;
  font-size: 18px;
  line-height: 220%;
  letter-spacing: 1px;
}
/* .contents-list img{        
        width: 196px;
        height: 171px;
    } */
.contents-banner {
  margin-top: 54px;
  margin-bottom: 43px;
  width: 411px;
  height: 110px;
}
.contents-right >>> .el-select {
  width: 100%;
}
.contents-right >>> .el-button--primary {
  background-color: #2655ae;
  border-color: #2655ae;
}
.contents-right >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}
/* .xieyeitem {
  margin-bottom: 0;
} */
.contents-right .xieyeitem {
  margin-bottom: 0;
}
.contents-right-title {
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #333;
  margin-top: 100px;
}
.contents-right-lable {
  font-weight: 400;
  font-size: 14px;
  line-height: 15px;
  color: #999;
  margin: 16px 0;
  margin-top: 10px;
}
.contacusbotton {
  float: right;
}
/* .xieyi .yinsi,.xieyi .yinsi a{
		color:#2655ae;
	} */
</style>



// WEBPACK FOOTER //
// src/views/user/contacus.vue